import React from 'react';

export const LandingPageContext = React.createContext<boolean>(false);
